import React, {Component} from "react";
import "./Portrait.css";

import Sketch from "./Sketch";
import P5Wrapper from "react-p5-wrapper";

export default class Portrait extends Component
{
	render()
	{
		return (
			<div className="portrait">
				<P5Wrapper sketch={Sketch} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Hero/Portrait/Portrait.js